export type MiscTaskTypeId =
  | 'Admission Consents'
  | 'Other Documents'
  | 'Discharge Consents'
  | 'Patient Consent'
  | 'Assignment of Benefits'
  | 'Eligibility Check'
  | 'E-Referral'
  | 'Get Authorization';

/**
 * Type of miscellaneous episode task.

Values are the human-readable labels shown in the Episode Manager, so the
task list can use them as ``display_name`` without a lookup table. The
backing column is a plain ``String``, so adding a member here needs no
migration.
 */
/**
 * Array of all MiscTaskTypeId values.
 * Type of miscellaneous episode task.

Values are the human-readable labels shown in the Episode Manager, so the
task list can use them as ``display_name`` without a lookup table. The
backing column is a plain ``String``, so adding a member here needs no
migration.
 */
export const MISCTASKTYPEID_VALUES: readonly MiscTaskTypeId[] = [
  'Admission Consents',
  'Other Documents',
  'Discharge Consents',
  'Patient Consent',
  'Assignment of Benefits',
  'Eligibility Check',
  'E-Referral',
  'Get Authorization',
] as const;
